import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SellerService } from 'src/app/shared/serviceLayer/seller-service';
import { SharedService } from 'src/app/shared/serviceLayer/shared.service';
import { SharedApiService } from 'src/app/shared/serviceLayer/shared-service';
import { ToastrService } from 'ngx-toastr';
@Component({
  standalone: false,
  selector: 'app-shipping',
  templateUrl: './shipping.component.html',
  styleUrls: ['./shipping.component.scss'],
})
export class ShippingComponent implements OnInit {
  uploadedFiles: any[] = [];
  shippingDetails: any;
  isDragging = false;
  imagesArray: any[] = [];
  token: any;
  type: any;
  isValidLink: boolean = true;
  errorMessage: string = '';
  maxFileSize = 5 * 1024 * 1024;
  isLoading: boolean = false;
  isSuccess: boolean = false;
  constructor(
    private route: Router,
    private router: ActivatedRoute,
    private sellerService: SellerService,
    private sharedService: SharedService,
    private sharedApiService: SharedApiService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.router.queryParams.subscribe((queryParams) => {
      this.token = queryParams['token'];
      this.type = queryParams['type'];

      if (this.token) {
        this.getInvDetails();
      }
    });
  }

  getInvDetails() {
    const data = {
      token: this.token,
    };
    this.sellerService.getShippingDetails(data).subscribe(
      (res: any) => {
        if (res.status === false) {
          this.isValidLink = false;
          this.errorMessage =
            'Invalid upload link. This link is either expired or incorrect. Please Request For New Link.';
        } else if (res) {
          this.shippingDetails = res.result;
          this.isValidLink = true;
        }
      },
      (error) => {
        this.isValidLink = false;
        this.errorMessage =
          'Invalid upload link. This link is either expired or incorrect.';
        console.error('Error fetching shipping details:', error);
      },
    );
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;

    const files = event.dataTransfer?.files;
    if (!files) return;

    const validFiles = this.handleFiles(files);

    if (validFiles.length > 0) {
      // Create a new FileList-like object with only valid files
      const dataTransfer = new DataTransfer();
      validFiles.forEach((file) => dataTransfer.items.add(file));

      this.bulkUpload({ target: { files: dataTransfer.files } }, 1);
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const validFiles = this.handleFiles(input.files);

      if (validFiles.length > 0) {
        // Create a new FileList-like object with only valid files
        const dataTransfer = new DataTransfer();
        validFiles.forEach((file) => dataTransfer.items.add(file));

        this.bulkUpload({ target: { files: dataTransfer.files } }, 1);
      }

      // Clear the input so user can select the same files again if needed
      // and to prevent accidental re-uploads
      input.value = '';
    }
  }
  handleFiles(files: FileList): File[] {
    const validFiles: File[] = [];
    const errors: string[] = [];

    // Check total limit including already uploaded images
    const totalImagesAfterUpload = this.imagesArray.length + files.length;
    if (totalImagesAfterUpload > 10) {
      this.toastr.error(`You can only upload a maximum of 10 images in total. You currently have ${this.imagesArray.length} image(s) uploaded.`,)
      return validFiles;
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (file.size > this.maxFileSize) {
        errors.push(`${file.name} exceeds the maximum file size of 5MB`);
        continue;
      }
      if (!this.isValidFileType(file)) {
        errors.push(
          `${file.name} has an invalid file type. Only images (JPG, JPEG, PNG) are allowed. Videos and PDFs are not accepted.`,
        );
        continue;
      }

      validFiles.push(file);
    }

    if (errors.length > 0) {
      this.toastr.error(errors.join('\n'));
    }

    return validFiles;
  }

  isValidFileType(file: File): boolean {
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    return validTypes.includes(file.type);
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
  }

  removeFile(index: number): void {
    this.imagesArray.splice(index, 1);
  }

  clearAll(): void {
    this.imagesArray = [];
  }

  async bulkUpload(e: any, type: any) {
    const files: FileList = e.target.files;
    if (!files || files.length === 0) {
      this.isLoading = false;
      return;
    }
    this.isLoading = true;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fd = new FormData();
      fd.append('files', file);
      fd.append('deviceId', await this.sharedService.getFingerprint());
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = async () => {
        await this.sharedApiService.globalFileUpload(fd).subscribe((res: any) => {
          if (
            type === 1 &&
            res.status &&
            res.validFiles &&
            res.validFiles.length > 0
          ) {
            const uploadedFile = res.validFiles[0];
            this.imagesArray.push({
              preview: reader.result,
              name: file.name,
              size: file.size,
              type: file.type,
              uploadedPath: uploadedFile.url,
            });
          }
          this.isLoading = false;
        });
      };
    }
  }

  uploadImages() {
    const images: string[] = [];

    for (const file of this.imagesArray) {
      if (file?.uploadedPath) {
        images.push(file.uploadedPath);
      }
    }

    const data = {
      token: this.token,
      images: images,
      type: this.type,
    };
    this.isLoading = true;
    this.sellerService.addShippingImages(data).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res.status === false) {
          this.isValidLink = false;
          this.errorMessage =
            'Invalid upload link. This link is either expired or incorrect. Please Request For New Link.';
        } else if (res) {
          this.shippingDetails = res.result;
          this.isValidLink = true;
          this.isSuccess = true;
        }
      },
      (error) => {
        this.isValidLink = false;
        this.errorMessage =
          'Invalid upload link. This link is either expired or incorrect.';
        console.error('Error fetching shipping details:', error);
      },
    );
  }
}



